( function( $, document, window ) {
	'use strict';

	// Slick Slideshow
	var columnsImages = document.querySelectorAll( '.column-section.-format_images .wrapper' ),
		slickifyImages;

	if ( columnsImages.length <= 0 ) {
		return;
	}

	slickifyImages = function( el, breakpointSettings ) {
		$( el ).slick( {
			autoplay: false,
			speed: 500,
			arrows: false,
			dots: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true,
			prevArrow: '',
			nextArrow: '',
			responsive: breakpointSettings
		} );
	};

	$( document ).ready( function() {

		var breakpointSettings = [{breakpoint: 767, settings: 'unslick'}];

		Array.from( columnsImages ).forEach( function( el ) {

			var themeSettings = $( 'body' ).data( 'image-columns-slick-settings' );

			// Add Slick settings above 767 if there's enough slides.
			if ( el.children.length > themeSettings.minSlides ) {
				breakpointSettings = themeSettings.responsive;
			}

			var screenWidth = window.innerWidth > 0 ? window.innerWidth : screen.width;
			var unslickWidth = themeSettings.unslickWidth ? themeSettings.unslickWidth : screenWidth + 1;

			// Run Slick
			if ( el.children.length > 1 && screenWidth < unslickWidth ) {
				slickifyImages( el, breakpointSettings );
			}
		} );
	} );

} )( jQuery, document, window );
